import React from 'react';

// Windows 11 Style Icon Components - Filled, colorful designs
export const ThisPCIcon = ({ size = 56, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <defs>
      <linearGradient id="monitorGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#0078D4"/>
        <stop offset="50%" stopColor="#00A4EF"/>
        <stop offset="100%" stopColor="#00BCF2"/>
      </linearGradient>
    </defs>
    {/* Monitor screen - vibrant blue gradient */}
    <rect x="4" y="5" width="16" height="12" rx="1" fill="url(#monitorGradient)" stroke="none"/>
    {/* Monitor stand */}
    <path d="M8 17H16" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10 17V19H14V17" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    {/* Person silhouette - white */}
    <circle cx="12" cy="10" r="2.5" fill="white"/>
    <path d="M8 13C8 11.5 9.5 10.5 12 10.5C14.5 10.5 16 11.5 16 13" stroke="white" strokeWidth="1.5" strokeLinecap="round" fill="white"/>
  </svg>
);

export const DocumentsIcon = ({ size = 56, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    {/* Folder body - yellow */}
    <path d="M4 6C4 5.44772 4.44772 5 5 5H9.58579C9.851 5 10.1054 5.10536 10.2929 5.29289L12.7071 7.70711C12.8946 7.89464 13.149 8 13.4142 8H19C19.5523 8 20 8.44772 20 9V18C20 18.5523 19.5523 19 19 19H5C4.44772 19 4 18.5523 4 18V6Z" fill="#FFB900" stroke="none"/>
    {/* Folder tab - darker yellow */}
    <path d="M4 6C4 5.44772 4.44772 5 5 5H9.58579C9.851 5 10.1054 5.10536 10.2929 5.29289L12.7071 7.70711C12.8946 7.89464 13.149 8 13.4142 8H19C19.5523 8 20 8.44772 20 9V9H4V6Z" fill="#FFC83D" stroke="none"/>
    {/* Blue stripe at bottom */}
    <rect x="4" y="16" width="16" height="3" fill="#0078D4" rx="0.5"/>
  </svg>
);

export const ChromeIcon = ({ size = 56, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    {/* Chrome circle segments - colored */}
    <path d="M12 3C15.5 3 18.5 5 19.5 8L12 12L4.5 8C5.5 5 8.5 3 12 3Z" fill="#EA4335"/>
    <path d="M19.5 8C20.5 10.5 20.5 13.5 19.5 16L12 12L19.5 8Z" fill="#34A853"/>
    <path d="M4.5 8L12 12L4.5 16C3.5 13.5 3.5 10.5 4.5 8Z" fill="#FBBC04"/>
    {/* Center circle - white */}
    <circle cx="12" cy="12" r="2.5" fill="white"/>
  </svg>
);

export const NotepadIcon = ({ size = 56, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <defs>
      <linearGradient id="notepadGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#FFFFFF"/>
        <stop offset="100%" stopColor="#E8F4F8"/>
      </linearGradient>
    </defs>
    {/* Notepad rectangle - white with subtle blue gradient */}
    <rect x="5" y="3" width="14" height="18" rx="1" fill="url(#notepadGradient)" stroke="#0078D4" strokeWidth="1.5"/>
    {/* Spiral binding - vibrant blue */}
    <path d="M8 3V21" stroke="#0078D4" strokeWidth="2.5" strokeLinecap="round" strokeDasharray="3 2"/>
    {/* Lines - blue-gray */}
    <line x1="10" y1="7" x2="17" y2="7" stroke="#4A90E2" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="10" y1="10" x2="17" y2="10" stroke="#4A90E2" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="10" y1="13" x2="17" y2="13" stroke="#4A90E2" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="10" y1="16" x2="14" y2="16" stroke="#4A90E2" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export const CommandPromptIcon = ({ size = 56, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    {/* Window frame - black/dark */}
    <rect x="2" y="4" width="20" height="16" rx="1" fill="#0C0C0C" stroke="#3F3F3F" strokeWidth="1"/>
    {/* Title bar - darker */}
    <rect x="2" y="4" width="20" height="4" rx="1" fill="#1F1F1F"/>
    {/* Prompt arrow - green */}
    <path d="M6 12L9 15L6 18" stroke="#16C60C" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    {/* Command line - green text */}
    <line x1="12" y1="15" x2="19" y2="15" stroke="#16C60C" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const RecycleBinIcon = ({ size = 56, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <defs>
      <linearGradient id="recycleGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#5B9BD5"/>
        <stop offset="50%" stopColor="#4472C4"/>
        <stop offset="100%" stopColor="#2E5597"/>
      </linearGradient>
    </defs>
    {/* Recycle bin body - blue gradient */}
    <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z" fill="url(#recycleGradient)" stroke="#1E3A8A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    {/* Lid */}
    <path d="M3 6H5H21" stroke="#1E3A8A" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
    {/* Recycling arrows - white */}
    <path d="M10 11V17M14 11V17" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="10" cy="9" r="1.5" fill="white" opacity="0.8"/>
    <circle cx="14" cy="9" r="1.5" fill="white" opacity="0.8"/>
  </svg>
);

export const FileExplorerIcon = ({ size = 56, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    {/* Same as DocumentsIcon - yellow folder with blue stripe */}
    <path d="M4 6C4 5.44772 4.44772 5 5 5H9.58579C9.851 5 10.1054 5.10536 10.2929 5.29289L12.7071 7.70711C12.8946 7.89464 13.149 8 13.4142 8H19C19.5523 8 20 8.44772 20 9V18C20 18.5523 19.5523 19 19 19H5C4.44772 19 4 18.5523 4 18V6Z" fill="#FFB900" stroke="none"/>
    <path d="M4 6C4 5.44772 4.44772 5 5 5H9.58579C9.851 5 10.1054 5.10536 10.2929 5.29289L12.7071 7.70711C12.8946 7.89464 13.149 8 13.4142 8H19C19.5523 8 20 8.44772 20 9V9H4V6Z" fill="#FFC83D" stroke="none"/>
    <rect x="4" y="16" width="16" height="3" fill="#0078D4" rx="0.5"/>
  </svg>
);

export const StoreIcon = ({ size = 56, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    {/* Windows Store icon - colorful */}
    <rect x="3" y="7" width="18" height="14" rx="1" fill="#0078D4"/>
    <path d="M3 7L5 3H19L21 7" fill="#00BCF2"/>
    <path d="M9 12L12 15L15 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
  </svg>
);

export const BrowserIcon = ({ size = 56, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    {/* Microsoft Edge icon - blue to green swirl */}
    <defs>
      <linearGradient id="edgeGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#0078D4"/>
        <stop offset="50%" stopColor="#00A4EF"/>
        <stop offset="100%" stopColor="#00BCF2"/>
      </linearGradient>
    </defs>
    <path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2Z" fill="url(#edgeGradient)"/>
    <path d="M12 2C15 2 17.5 4 18.5 7C19.5 10 19 13 17.5 15.5C16 18 13.5 20 12 20C10.5 20 8 18 6.5 15.5C5 13 4.5 10 5.5 7C6.5 4 9 2 12 2Z" fill="#00BCF2" opacity="0.8"/>
    <path d="M12 2C14 2 15.5 3.5 16.5 5.5C17.5 7.5 17.5 10 16.5 12.5C15.5 15 13.5 17 12 17C10.5 17 8.5 15 7.5 12.5C6.5 10 6.5 7.5 7.5 5.5C8.5 3.5 10 2 12 2Z" fill="#16C60C" opacity="0.9"/>
  </svg>
);

// Icon mapping for easy lookup
export const Windows11IconMap = {
  'mycomputer': ThisPCIcon,
  'this-pc': ThisPCIcon,
  'documents': DocumentsIcon,
  'chrome': ChromeIcon,
  'notepad': NotepadIcon,
  'cmd': CommandPromptIcon,
  'command-prompt': CommandPromptIcon,
  'recyclebin': RecycleBinIcon,
  'recycle-bin': RecycleBinIcon,
  'explorer': FileExplorerIcon,
  'file-explorer': FileExplorerIcon,
  'store': StoreIcon,
  'browser': BrowserIcon,
  'edge': BrowserIcon,
  'microsoft-edge': BrowserIcon,
};
